var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    enableBackground: "new",
    viewBox: "0 0 6.615 6.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdbb32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec8d2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fa9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02578c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.529,
    x2: 6.086,
    y1: 42.201,
    y2: 42.201,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1.059,
    x2: 5.568,
    y1: 42.2,
    y2: 42.2,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 2.117,
    x2: 4.498,
    y1: 45.244,
    y2: 45.244,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -39.688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "m 0.9255249,40.216666 c -0.21761918,0 -0.39635551,0.178739 -0.39635824,0.396359 v 3.176032 c 2.73e-6,0.21762 0.17873906,0.396359 0.39635824,0.396359 h 4.7640502 c 0.2176192,0 0.3963556,-0.178739 0.3963582,-0.396359 v -3.176032 c -2.6e-6,-0.21762 -0.178739,-0.396359 -0.3963582,-0.396359 z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    paintOrder: "markers fill stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "m 2.7770915,44.715099 c -0.1763885,0 -0.3368132,0.08308 -0.4568197,0.203089 -0.1200065,0.120004 -0.2030884,0.282498 -0.2030884,0.458888 v 0.263548 a 0.13230489,0.13230489 0 0 0 0.1307414,0.132808 h 2.1171834 a 0.13230489,0.13230489 0 0 0 0.1328084,-0.132808 v -0.263548 c 0,-0.17639 -0.085149,-0.338884 -0.2051555,-0.458888 C 4.1727545,44.798183 4.01233,44.715099 3.8359416,44.715099 Z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    paintOrder: "markers fill stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "m 1.1895915,40.743248 a 0.13230489,0.13230489 0 0 0 -0.013953,0.0011 0.13230489,0.13230489 0 0 0 -0.1167887,0.134877 v 2.644283 a 0.13230489,0.13230489 0 0 0 0.1328083,0.132783 h 4.2322998 a 0.13230489,0.13230489 0 1 0 0,-0.263548 H 1.3223999 V 40.879159 A 0.13230489,0.13230489 0 0 0 1.1895915,40.743248 Z m 3.7041666,0.265102 a 0.13230489,0.13230489 0 0 0 -0.014986,0.0016 0.13230489,0.13230489 0 0 0 -0.078031,0.03876 L 4.1015586,41.749942 3.6659264,41.314311 a 0.13230489,0.13230489 0 0 0 -0.1989542,0.01394 l -0.7033165,0.937411 -0.4216796,-0.42168 a 0.13230489,0.13230489 0 0 0 -0.2030883,0.01913 l -0.5296835,0.793232 a 0.13244567,0.13244567 0 1 0 0.2206584,0.146246 l 0.4397664,-0.659908 0.4159954,0.415993 a 0.13230489,0.13230489 0 0 0 0.1989542,-0.01394 l 0.7012491,-0.937411 0.4221966,0.422196 a 0.13230489,0.13230489 0 0 0 0.1870687,0 l 0.7932332,-0.793232 a 0.13230489,0.13230489 0 0 0 -0.094568,-0.227893 z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c49677543d682ae07a6d1e95f9622adc.svg";
export { ForwardRef as ReactComponent };